import { render, staticRenderFns } from "./NewCallDrawer.vue?vue&type=template&id=2754b3ec&scoped=true"
import script from "./NewCallDrawer.vue?vue&type=script&lang=js"
export * from "./NewCallDrawer.vue?vue&type=script&lang=js"
import style0 from "./NewCallDrawer.vue?vue&type=style&index=0&id=2754b3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2754b3ec",
  null
  
)

export default component.exports